export type EstrategiaKey = 'OFENSIVA' | 'DEFENSIVA' | 'CONFRONTO' | 'REFORCO';
export type EstrategiaName = 'Ofensiva' | 'Defensiva' | 'Confronto' | 'Reforço';

export interface Estrategia {
  key: EstrategiaKey;
  nome: EstrategiaName;
  descricao: string;
}

export const ESTRATEGIAS: ReadonlyArray<Estrategia> = [
  {
    key: 'OFENSIVA',
    nome: 'Ofensiva',
    descricao:
      'Busca alavancar os pontos fortes da organização para aproveitar oportunidades do ambiente externo, promovendo crescimento, expansão e posicionamento competitivo. Foca em iniciativas proativas, inovação, fortalecimento institucional e ampliação de impacto.',
  },
  {
    key: 'DEFENSIVA',
    nome: 'Defensiva',
    descricao:
      'Tem como objetivo reduzir vulnerabilidades internas e minimizar a exposição a ameaças externas. Envolve ajustes estruturais, correção de falhas, racionalização de processos e fortalecimento da governança para preservar a continuidade e a estabilidade organizacional.',
  },
  {
    key: 'CONFRONTO',
    nome: 'Confronto',
    descricao:
      'Utiliza os pontos fortes para enfrentar, neutralizar ou reduzir ameaças externas. Prioriza ações de proteção do posicionamento estratégico, defesa institucional, aumento de competitividade e mitigação de riscos que possam comprometer resultados ou sustentabilidade.',
  },
  {
    key: 'REFORCO',
    nome: 'Reforço',
    descricao:
      'Foca no desenvolvimento de capacidades internas para aproveitar oportunidades externas. Envolve capacitação, melhoria de processos, investimentos estruturantes e fortalecimento organizacional, preparando a instituição para crescer de forma sustentável e alinhada ao ambiente.',
  },
] as const;

export const ESTRATEGIA_POR_CHAVE = Object.fromEntries(
  ESTRATEGIAS.map((estrategia) => [estrategia.key, estrategia])
) as Record<EstrategiaKey, Estrategia>;

export const ESTRATEGIA_POR_NOME = Object.fromEntries(
  ESTRATEGIAS.map((estrategia) => [estrategia.nome, estrategia])
) as Record<EstrategiaName, Estrategia>;